import fetcher from 'api/fetcher';
import { AxiosError } from 'axios';
import { NotificationName } from 'utils/constants/notification';
import Debug from 'utils/debug';
import { getXRequestId } from 'utils/getXRequestId';

import { ProductTypes } from 'components/Dashboard/Filters/consts';

import { FiltersList, setFiltersList, setIsLoadingFiltersList } from 'store/models/dashboard';
import { addNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const fetchFiltersList = (): AppThunkAction<Promise<void> | null> => {
    return (dispatch) => {
        dispatch(setIsLoadingFiltersList(true));

        return fetcher
            .get<unknown, FiltersList>(`/api/v1/campaigns/filter`, {
                timeout: 30000,
            })
            .then((filters) => {
                dispatch(setFiltersList(filters));
            })
            .catch((response: AxiosError<Error>) => {
                dispatch(
                    setFiltersList({
                        productTypes: [ProductTypes.Cpc, ProductTypes.Auction],
                    })
                );

                Debug.log('error out', 'filters load error', {
                    message: response.message,
                    xRequestId: getXRequestId(response),
                });

                dispatch(addNotification(NotificationName.DashboardLoadFiltersSomethingWentWrong));
            })
            .finally(() => {
                dispatch(setIsLoadingFiltersList(false));
            });
    };
};
